<section id="content">
	<div class="spinner-container">
		<div class="spinner">
			<div class="sk-folding-cube">
				<div class="sk-cube1 sk-cube"></div>
				<div class="sk-cube2 sk-cube"></div>
				<div class="sk-cube4 sk-cube"></div>
				<div class="sk-cube3 sk-cube"></div>
			</div>
		</div>
	</div>

	<div class="form-group">
		<div class="card">
			<div class="card-title">
				<h2>Lookup Management</h2>
			</div>
			<p-messages [escape]="true" [value]="msgs"></p-messages>
			<div class="cont">
				<div class="group" sec:authorize="hasAuthority('lookup_management')">
					<div class="collapse-title"
						(click)="ele.class = ele.class == 'hideChildren' ? '' :  'hideChildren'">Lookup Management
						<i class="collapse-icon fa"
							[ngClass]=" ele.class !== 'hideChildren' ? 'fa-minus' : 'fa-plus'"></i>
					</div>
					<div class="collapse in show" id="lookupManagementGroup"
						[ngClass]="{ hideChildren : ele.class == 'hideChildren' }" #ele>
						<div class="group-cont">
							<div class="form-group">
								<div class="row">
									<div class="col-md-6 col-xs-12">
										<div class="inputs">
											<select #lookupSelectorEle id="lookupSelector"
												(change)="onDropDownClicked($event)">
												<option selected="">Select</option>
												<option value="Source">Source</option>
												<option value="Sector">Sector</option>
												<option value="Status">Status</option>
												<option value="Role">Roles</option>
												<option value="Region">Region</option>
												<option value="CustomerNeed">Customer Need</option>
												<option value="SalesRep">Sales Represenative</option>
												<option value="ProductType">Product Type</option>
												<option value="Item">Item</option>
												<option value="Category">Category</option>
												<option value="Product">Product</option>
												<!-- <option value="SalesRep">SalesRep</option> -->
											</select> <label for="lookupSelector">Lookup</label>
										</div>
									</div>
								</div>
								<!-- /.row -->
							</div>

							<div class="table-responsive" [hidden]="!displayCreationRow">

								<!-- Column Header -->
								<form name="myForm" #f="ngForm" novalidate (ngSubmit)="onSubmit($event)"
									[hidden]="displayProductTable || displaySalesRepTable || displayProductTypeTable || displayRolesTable">
									<table class="table editable" id="lookup-table" width="100%">
										<thead>
											<tr>
												<th class="empIduser">{{lookupColumnHeader}}</th>
												<th class="text-center" width="10%">
													<span class="add">
														<i class="la la-plus"
															(click)="showAddRow($event,'nonstatus')"></i>
													</span>
												</th>
											</tr>
										</thead>
										<tr height="110px" [class]="addRowClass">
											<td style="vertical-align: top;">

												<input type="text" name="name" class="form-control"
													[(ngModel)]="model.name" #name="ngModel" class="input" required>
												<div *ngIf="f.submitted && name.invalid" class="alert alert-danger">
													<div *ngIf="name.errors.required">Value is required</div>
												</div>

											</td>

											<td class="options" style="vertical-align: top;">
												<ul class="actions">
													<li class="confirm">
														<!--<i class="la la-check commit" id="x1" onclick="myForm.submit();"></i>-->
														<button id="finish"
															style="background-color: #36D9B0;border: 0;color: white;"><i
																class="la la-check commit" id="x1"></i></button>
													</li>
													<li class="cancel">
														<i class="la la-close" (click)="closeAddRow($event)"></i>
													</li>
												</ul>
											</td>
										</tr>
										<tr *ngFor="let lookupBean of lookupList; let i = index"
											(dblclick)="editUserData($event,lookupBean.Id)">
											<td>
												<input type="text" value="{{lookupBean?.name}}" class="disabled">
											</td>
											<td>
												<ul>
													<li class="delete text-red"><i class="la la-trash"
															(click)="deleteRow($event,lookupBean.Id)"></i></li>
												</ul>
											</td>
										</tr>
									</table>
								</form>
							</div>


							<div class="table-responsive" [hidden]="!displayProductTypeTable">

								<!-- Column Header -->
								<form name="ProductTypeForm" #ProductTypeForm="ngForm" novalidate (ngSubmit)="onSubmit($event)"
									[hidden]="displayProductTable || displaySalesRepTable ">
									<table class="table editable" id="lookup-table" width="100%">
										<thead>
											<tr>
												<th class="empIduser">Product Type</th>
												<th class="empIduser">Reorder Level</th>
												<th class="empIduser">Reorder Available</th>
												<th class="text-center" width="10%">
													<span class="add">
														<i class="la la-plus"
															(click)="showAddRow($event,'nonstatus')"></i>
													</span>
												</th>
											</tr>
										</thead>
										<tr height="110px" [class]="addRowClass">
											<td style="vertical-align: top;">

												<input type="text" name="productType" class="form-control"
													[(ngModel)]="productTypeModel.productType" #productType="ngModel" class="input" required>
												<div *ngIf="ProductTypeForm.submitted && productType.invalid" class="alert alert-danger">
													<div *ngIf="productType.errors.required">Value is required</div>
												</div>

											</td>

											<td style="vertical-align: top;">

												<input type="number" name="reorderLevel" class="form-control"
													[(ngModel)]="productTypeModel.reorderLevel" #reorderLevel="ngModel" class="input" required>
												<div *ngIf="ProductTypeForm.submitted && reorderLevel.invalid" class="alert alert-danger">
													<div *ngIf="reorderLevel.errors.required">Value is required</div>
												</div>

											</td>

											<td class="options" style="vertical-align: top;">
												<ul class="actions">
													<li class="confirm">
														<!--<i class="la la-check commit" id="x1" onclick="myForm.submit();"></i>-->
														<button id="saveProductType"
															style="background-color: #36D9B0;border: 0;color: white;"><i
																class="la la-check commit" id="x1"></i></button>
													</li>
													<li class="cancel">
														<i class="la la-close" (click)="closeAddRow($event)"></i>
													</li>
												</ul>
											</td>
										</tr>
										<tr *ngFor="let lookupBean of lookupList; let i = index"
											(dblclick)="modifyProductType($event,lookupBean.typeId)">
											<td>
												<input type="text" value="{{lookupBean?.productType}}" class="disabled">
											</td>
											<td>
												<input type="text" value="{{lookupBean?.reorderLevel}}" class="disabled">
											</td>
											<td>
												<input type="text" value="{{lookupBean?.reorderAvailable}}" class="disabled">
											</td>
											<td>
												<ul>
													<li class="delete text-red"><i class="la la-trash"
															(click)="deleteRow($event,lookupBean.typeId)"></i></li>
												</ul>
											</td>
										</tr>
									</table>
								</form>
							</div>

							<div class="table-responsive" [hidden]="!displayRolesTable">
								<form [formGroup]="myRoleGroup" name="roleForm" #roleForm="ngForm" novalidate
									(ngSubmit)="onSubmit($event)">

									<p-tabView (onChange)="onTabChange($event)">

										<p-tabPanel header="Cadence Roles" >
											
											<table class="table editable" id="role-lookup-table">
												<thead>

													<tr>
														<th class="userRolelookup">User Role</th>
														<th class="userManagementlookup">User Management</th>
														<th class="customerManagementlookup">Customer Management</th>
														<th class="Managementlookup">Management</th>
														<th class="techLeadAccess">Technical Lead Access</th>
														<th class="text-center">
															<span class="add"><i class="la la-plus"
																	(click)="showAddRow($event, 'role')"></i></span>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr height="110px" [class]="addRowClass">
														<td style="vertical-align: top;">

															<input type="text" name="userRole"
																formControlName="userRole" class="form-control"
																[(ngModel)]="roleModel.userRole" class="input" required>
															<div *ngIf="myRoleGroup.controls['userRole'].invalid && (myRoleGroup.controls['userRole'].dirty || myRoleGroup.controls['userRole'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['userRole'].errors.required">
																	Role required.
																</div>
															</div>
														</td>
														<td style="vertical-align: top;">
															<select class="input" required
																formControlName="userManagement"
																[(ngModel)]="roleModel.userManagement">
																<option value="true">true</option>
																<option value="false">false</option>
															</select>
															<div *ngIf="myRoleGroup.controls['userManagement'].invalid && (myRoleGroup.controls['userManagement'].dirty || myRoleGroup.controls['userManagement'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['userManagement'].errors.required">
																	User Management required.
																</div>
															</div>

														</td>
														<td style="vertical-align: top;">
															<select class="input" required
																formControlName="customerManagement"
																[(ngModel)]="roleModel.customerManagement">
																<option value="true">true</option>
																<option value="false">false</option>
															</select>
															<div *ngIf="myRoleGroup.controls['customerManagement'].invalid && (myRoleGroup.controls['customerManagement'].dirty || myRoleGroup.controls['userManagement'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['customerManagement'].errors.required">
																	Customer Management required.
																</div>
															</div>

														</td>
														<td style="vertical-align: top;">
															<select class="input" required
																formControlName="lookupManagement"
																[(ngModel)]="roleModel.lookupManagement">
																<option value="true">true</option>
																<option value="false">false</option>
															</select>
															<div *ngIf="myRoleGroup.controls['lookupManagement'].invalid && (myRoleGroup.controls['lookupManagement'].dirty || myRoleGroup.controls['userManagement'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['lookupManagement'].errors.required">
																	Management required.
																</div>
															</div>

														</td>
														<td style="vertical-align: top;">
															<select class="input" required
																formControlName="techLeadAccess"
																[(ngModel)]="roleModel.techLeadAccess">
																<option value="true">true</option>
																<option value="false">false</option>
															</select>
															<div *ngIf="myRoleGroup.controls['techLeadAccess'].invalid && (myRoleGroup.controls['techLeadAccess'].dirty || myRoleGroup.controls['techLeadAccess'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['techLeadAccess'].errors.required">
																	Tech Lead Role is required.
																</div>
															</div>

														</td>
														<td style="vertical-align: top;" class="options">
															<ul class="actions">
																<li class="confirm">
																	<button id="saveRole"
																		style="background-color: #36D9B0;border: 0;color: white;"><i
																			class="la la-check commit"
																			id="x231"></i></button>

																</li>
																<li class="cancel">
																	<i class="la la-close"
																		(click)="closeAddRow($event)"></i>
																</li>
															</ul>
														</td>
													</tr>
													<tr *ngFor="let role of rolesList; let i = index"
														(dblclick)="modifyRole($event,role.roleId , 'Cadence')">
														<td>
															<input type="text" name="userRole"
																value="{{role?.userRole}}" class="disabled">
														</td>
														<td>
															<input type="text" name="userManagement"
																value="{{role?.userManagement}}" class="disabled">

														</td>
														<td>
															<input type="text" name="customerManagement"
																value="{{role?.customerManagement}}" class="disabled">

														</td>
														<td>
															<input type="text" name="lookupManagement"
																value="{{role?.lookupManagement}}" class="disabled">

														</td>
														<td>
															<input type="text" name="techLeadAccess"
																value="{{role?.techLeadAccess}}" class="disabled">

														</td>
														<td>
															<ul>
																<li class="delete text-red"><i class="la la-trash"
																		(click)="deleteRow($event,role.roleId)"></i>
																</li>
															</ul>
														</td>
													</tr>
											</table>
									
										</p-tabPanel>

										<p-tabPanel header="Appliance Roles" >
											<table class="table editable" id="role-lookup-table">
												<thead>

													<tr>
														<th>Role Name</th>
														<th>Order Management</th>
														<th>Stock Management</th>
														<th>Inventory Management</th>
														<th>File Processing</th>
														<th>RFP Management</th>
														<th>Prospects Management</th>
														<th>Access Level</th>
														<th class="text-center">
															<span class="add"><i class="la la-plus"
																	(click)="showAddRow($event, 'role')"></i></span>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr height="110px" [class]="addRowClass">
														<td style="vertical-align: top;">

															<input type="text" name="roleName"
																formControlName="roleName" class="form-control"
																[(ngModel)]="applianceRoleModel.roleName" class="input" required>
															<div *ngIf="myRoleGroup.controls['roleName'].invalid && (myRoleGroup.controls['roleName'].dirty || myRoleGroup.controls['roleName'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['roleName'].errors.required">
																	Role Name required.
																</div>
															</div>
														</td>
														<td style="vertical-align: top;">
															<select class="input" required
																formControlName="orderManagement"
																[(ngModel)]="applianceRoleModel.orderManagement">
																<option value="true">true</option>
																<option value="false">false</option>
															</select>
															<div *ngIf="myRoleGroup.controls['orderManagement'].invalid && (myRoleGroup.controls['orderManagement'].dirty || myRoleGroup.controls['orderManagement'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['orderManagement'].errors.required">
																	Order Management required.
																</div>
															</div>

														</td>
														<td style="vertical-align: top;">
															<select class="input" required
																formControlName="stockManagement"
																[(ngModel)]="applianceRoleModel.stockManagement">
																<option value="true">true</option>
																<option value="false">false</option>
															</select>
															<div *ngIf="myRoleGroup.controls['stockManagement'].invalid && (myRoleGroup.controls['stockManagement'].dirty || myRoleGroup.controls['stockManagement'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['stockManagement'].errors.required">
																	Stock Management required.
																</div>
															</div>

														</td>
														<td style="vertical-align: top;">
															<select class="input" required
																formControlName="inventoryManagement"
																[(ngModel)]="applianceRoleModel.inventoryManagement">
																<option value="true">true</option>
																<option value="false">false</option>
															</select>
															<div *ngIf="myRoleGroup.controls['inventoryManagement'].invalid && (myRoleGroup.controls['inventoryManagement'].dirty || myRoleGroup.controls['inventoryManagement'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['inventoryManagement'].errors.required">
																	Inventory Management required.
																</div>
															</div>

														</td>

														<td style="vertical-align: top;">
															<select class="input" required
																formControlName="fileProcessingManagement"
																[(ngModel)]="applianceRoleModel.fileProcessingManagement">
																<option value="true">true</option>
																<option value="false">false</option>
															</select>
															<div *ngIf="myRoleGroup.controls['fileProcessingManagement'].invalid && (myRoleGroup.controls['fileProcessingManagement'].dirty || myRoleGroup.controls['fileProcessingManagement'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['fileProcessingManagement'].errors.required">
																	File Processing Management required.
																</div>
															</div>

														</td>

														<td style="vertical-align: top;">
															<select class="input" required
																formControlName="RFPManagement"
																[(ngModel)]="applianceRoleModel.RFPManagement">
																<option value="true">true</option>
																<option value="false">false</option>
															</select>
															<div *ngIf="myRoleGroup.controls['RFPManagement'].invalid && (myRoleGroup.controls['RFPManagement'].dirty || myRoleGroup.controls['RFPManagement'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['RFPManagement'].errors.required">
																	RFP Management required.
																</div>
															</div>

														</td>

														<td style="vertical-align: top;">
															<select class="input" required
																formControlName="prospectsManagement"
																[(ngModel)]="applianceRoleModel.prospectsManagement">
																<option value="true">true</option>
																<option value="false">false</option>
															</select>
															<div *ngIf="myRoleGroup.controls['prospectsManagement'].invalid && (myRoleGroup.controls['prospectsManagement'].dirty || myRoleGroup.controls['prospectsManagement'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['prospectsManagement'].errors.required">
																	Prospects Management required.
																</div>
															</div>

														</td>

														<td style="vertical-align: top;">
															<select class="input" required
																formControlName="accessLevel"
																[(ngModel)]="applianceRoleModel.accessLevel">
																<option value=0>0 (NO_ACCESS)</option>
																<option value=1>1 (READ_ONLY)</option>
																<option value=2>2 (UPDATE)</option>
																<option value=3>3 (FULL)</option>
															</select>
															<div *ngIf="myRoleGroup.controls['accessLevel'].invalid && (myRoleGroup.controls['accessLevel'].dirty || myRoleGroup.controls['accessLevel'].touched)"
																class="alert alert-danger">
																<div
																	*ngIf="myRoleGroup.controls['accessLevel'].errors.required">
																	Access Level Role is required.
																</div>
															</div>

														</td>
														<td style="vertical-align: top;" class="options">
															<ul class="actions">
																<li class="confirm">
																	<button id="saveRole"
																		style="background-color: #36D9B0;border: 0;color: white;"><i
																			class="la la-check commit"
																			id="x231"></i></button>

																</li>
																<li class="cancel">
																	<i class="la la-close"
																		(click)="closeAddRow($event)"></i>
																</li>
															</ul>
														</td>
													</tr>
													<tr *ngFor="let role of applianceRoleList; let i = index"
														(dblclick)="modifyRole($event,role.roleId ,'Appliance' )">
														<td>
															<input type="text" name="roleName"
																value="{{role?.roleName}}" class="disabled">
														</td>
														<td>
															<input type="text" name="orderManagement"
																value="{{role?.orderManagement}}" class="disabled">

														</td>
														<td>
															<input type="text" name="stockManagement"
																value="{{role?.stockManagement}}" class="disabled">

														</td>
														<td>
															<input type="text" name="inventoryManagement"
																value="{{role?.inventoryManagement}}" class="disabled">

														</td>
														<td>
															<input type="text" name="fileProcessingManagement"
																value="{{role?.fileProcessingManagement}}" class="disabled">

														</td>
														<td>
															<input type="text" name="RFPManagement"
																value="{{role?.RFPManagement}}" class="disabled">

														</td>
														<td>
															<input type="text" name="prospectsManagement"
																value="{{role?.prospectsManagement}}" class="disabled">

														</td>

														<td>
															<input type="text" name="accessLevel"
																[value]="getApplianceRoleName(role?.accessLevel)" class="disabled">
															
														</td>
														<td>
															<ul>
																<li class="delete text-red"><i class="la la-trash"
																		(click)="deleteRow($event,role.roleId)"></i>
																</li>
															</ul>
														</td>
													</tr>
											</table>

										</p-tabPanel>
									</p-tabView>

								</form>

							</div>
							<div class="table-responsive" [hidden]="!displayProductTable">
								<form name="productForm" #productForm="ngForm" novalidate (ngSubmit)="onSubmit($event)">
									<table class="table editable" id="product-lookup-table" width="100%">
										<thead>
											<tr>
												<th>Product Type</th>
												<th>Category</th>
												<th>Item</th>
												<th>Product Kind</th>
												<th>Part Number</th>
												<th>Is License</th>
												<th class="text-center" width="10%">
													<span class="add">
														<i class="la la-plus"
															(click)="showAddRow($event, 'product')"></i>
													</span>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr height="110px" [class]="addRowClass">

												<td style="vertical-align: top;">
													<select class="input" required
														[(ngModel)]="productModel.productType " #productType="ngModel"
														name="productType">
														<option value="" disabled selected>Select Product Type</option>
														<option *ngFor="let productTypeObject of productTypeList"
															[value]="productTypeObject.productType">{{
															productTypeObject.productType }}</option>
													</select>
													<div *ngIf="productForm.submitted && productType.invalid"
														class="alert alert-danger">
														<div *ngIf="productType.errors.required">Product Type is
															required</div>
													</div>
												</td>
												<td style="vertical-align: top;">
													<select class="input" required
														[(ngModel)]="productModel.productCategory"
														#productCategory="ngModel" name="productCategory">
														<option value="" disabled selected>Select Category</option>
														<option *ngFor="let categoryObject of categorieslist"
															[value]="categoryObject.category">{{ categoryObject.category
															}}</option>
													</select>
													<div *ngIf="productForm.submitted && productCategory.invalid"
														class="alert alert-danger">
														<div *ngIf="productCategory.errors.required">Category is
															required</div>
													</div>
												</td>
												<td style="vertical-align: top;">
													<select class="input" required
														[(ngModel)]="productModel.productItem" #productItem="ngModel"
														name="productItem">
														<option value="" disabled selected>Select Item</option>
														<option *ngFor="let itemObject of items"
															[value]="itemObject.item">{{ itemObject.item }}</option>
													</select>
													<div *ngIf="productForm.submitted && productItem.invalid"
														class="alert alert-danger">
														<div *ngIf="productItem.errors.required">Item is required</div>
													</div>
												</td>
												<td style="vertical-align: top;">
													<select class="input" required
														[(ngModel)]="productModel.productKind" #productItem="ngModel"
														name="productItem" >
														<option value="" disabled selected>Select Product Kind</option>
														<option value="SWG" selected>SWG</option>
														<option value="STG" selected>STG</option>

													</select>
													<!-- <input type="text" name="productKind" class="form-control" [(ngModel)]="productModel.productKind"
														#productKind="ngModel" class="select" required>
													<div *ngIf="productForm.submitted && productKind.invalid" class="alert alert-danger">
														<div *ngIf="productKind.errors.required">Product Kind is required</div>
													</div> -->
												</td>


												<td style="vertical-align: top;">
													<input type="text" name="partNumber" class="form-control"
														[(ngModel)]="productModel.partNumber" #partNumber="ngModel"
														class="input" required>
													<div *ngIf="productForm.submitted && partNumber.invalid"
														class="alert alert-danger">
														<div *ngIf="partNumber.errors.required">Part Number is required</div>
													</div>
												</td>

												<td style="vertical-align: top;">

													<select class="input" required
													[(ngModel)]="productModel.isLicense" #productItem="ngModel"
													name="productItem" >
													<option value="" disabled selected>Select is Lisence</option>
													<option value="true" selected>True</option>
													<option value="false" selected>False</option>

												</select>

												</td>

												<td class="options" style="vertical-align: top;">
													<ul class="actions">
														<li class="confirm">
															<button id="saveProduct"
																style="background-color: #36D9B0;border: 0;color: white;"><i
																	class="la la-check commit"></i></button>
														</li>
														<li class="cancel">
															<i class="la la-close" (click)="closeAddRow($event)"></i>
														</li>
													</ul>
												</td>
											</tr>

											<tr *ngFor="let product of productList; let i = index">
												<td>{{product.productType ? product.productType.productType: "NON" }}
												</td>
												<td>{{product.productCategory.category}}</td>
												<td>{{product.productItem.item}}</td>
												<td>{{product.productKind}}</td>
												<td>{{product.partNumber}}</td>
												<td>{{product.isLicense}}</td>

											</tr>
										</tbody>
									</table>
								</form>
							</div>

							<div class="table-responsive" [hidden]="!displayStatusTable">
								<form name="statusForm" #statusForm="ngForm" novalidate (ngSubmit)="onSubmit($event)">
									<table class="table editable" id="status-lookup-table">
										<thead>
											<tr>
												<th class="statuslookup">Status</th>
												<th class="typelookup">Type</th>
												<th class="oddslookup">Odds</th>
												<th class="text-center">
													<span class="add"><i class="la la-plus"
															(click)="showAddRow($event, 'status')"></i></span>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr height="110px" [class]="addRowClass">
												<td style="vertical-align: top;">

													<input type="text" name="status" class="form-control"
														[(ngModel)]="statusModel.status" #status="ngModel" class="input"
														required>
													<div *ngIf="statusForm.submitted && status.invalid"
														class="alert alert-danger">
														<div *ngIf="status.errors.required">Status is required</div>
													</div>

												</td>
												<td style="vertical-align: top;">
													<input type="text" name="type" class="form-control"
														[(ngModel)]="statusModel.type" #type="ngModel" class="input"
														required>
													<div *ngIf="statusForm.submitted && type.invalid"
														class="alert alert-danger">
														<div *ngIf="type.errors.required">Type is required</div>
													</div>

												</td>
												<td style="vertical-align: top;">
													<input type="text" name="odds" class="form-control"
														[(ngModel)]="statusModel.odds" #odds="ngModel" class="input"
														required>
													<div *ngIf="statusForm.submitted && odds.invalid"
														class="alert alert-danger">
														<div *ngIf="odds.errors.required">Odds is required</div>
													</div>
												</td>
												<td class="options" style="vertical-align: top;">
													<ul class="actions">
														<li class="confirm">
															<button id="saveStatus"
																style="background-color: #36D9B0;border: 0;color: white;"><i
																	class="la la-check commit" id="x231"></i></button>
														</li>
														<li class="cancel">
															<i class="la la-close" (click)="closeAddRow($event)"></i>
														</li>
													</ul>
												</td>
											</tr>
											<tr *ngFor="let status of statusList; let i = index"
												(dblclick)="modifyStatus($event,status.statusId)">
												<td>
													<input type="text" value="{{status?.status}}" class="disabled">
												</td>
												<td>
													<input type="text" value="{{status?.type}}" class="disabled">
												</td>
												<td>
													<input type="text" value="{{status?.odds}}" class="disabled">
												</td>
												<td>
													<ul>
														<li class="delete text-red"><i class="la la-trash"
																(click)="deleteRow($event,status.statusId)"></i></li>
													</ul>
												</td>
											</tr>

									</table>
								</form>

							</div>


							<div class="table-responsive" [hidden]="!displaySalesRepTable">
								<form name="SalesRepForm" #SalesRepForm="ngForm" novalidate
									(ngSubmit)="onSubmit($event)">
									<table class="table editable" id="salesRep-lookup-table">
										<thead>
											<tr>
												<th class="namelookup">Name</th>
												<th class="phonelookup">Phone</th>
												<th class="emaillookup">Email</th>
												<th class="text-center">
													<span class="add"><i class="la la-plus"
															(click)="showAddRow($event,'sales')"></i></span>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr height="110px" [class]="addRowClass">
												<td style="vertical-align: top;">

													<input type="text" name="name" class="form-control"
														[(ngModel)]="salesModel.name" #name="ngModel" class="input"
														required>
													<!-- <div *ngIf="SalesRepForm.submitted && name.invalid"
														class="alert alert-danger">
														<div *ngIf="name.errors.required">Name is required</div>
													</div> -->

												</td>
												<td style="vertical-align: top;">
													<input type="text" name="phone" class="form-control"
														[(ngModel)]="salesModel.phone" #phone="ngModel" class="input"
														required>
													<div *ngIf="SalesRepForm.submitted && phone.invalid"
														class="alert alert-danger">
														<div *ngIf="phone.errors.required">Phone is required</div>
													</div>

												</td>
												<td style="vertical-align: top;">
													<input type="text" name="email" class="form-control"
														[(ngModel)]="salesModel.email" #email="ngModel" class="input"
														required>
													<div *ngIf="SalesRepForm.submitted && email.invalid"
														class="alert alert-danger">
														<div *ngIf="email.errors.required">Email is required</div>
													</div>
												</td>
												<td class="options" style="vertical-align: top;">
													<ul class="actions">
														<li class="confirm">
															<button id="saveSales"
																style="background-color: #36D9B0;border: 0;color: white;"><i
																	class="la la-check commit" id="x231"></i></button>
														</li>
														<li class="cancel">
															<i class="la la-close" (click)="closeAddRow($event)"></i>
														</li>
													</ul>
												</td>
											</tr>

											<tr *ngFor="let sales of salesRepList; let i = index"
												(dblclick)="modifySalesRep($event,sales.id)">
												<td>
													<input type="text" value="{{sales.name}}" class="disabled">
												</td>
												<td>
													<input type="text" value="{{sales.phone}}" class="disabled">
												</td>
												<td>
													<input type="text" value="{{sales.email}}" class="disabled">
												</td>
												<td>
													<ul>
														<li class="delete text-red"><i class="la la-trash"
																(click)="deleteRow($event,sales.id)"></i></li>
													</ul>
												</td>
											</tr>

									</table>
								</form>
							</div>




						</div>
						<!-- /.group-cont -->
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<form #updateForm="ngForm" novalidate (ngSubmit)="onUpdateSubmit($event)">

	<p-dialog header="Details" [visible]="displayDialog" [modal]="true" width="1000" height="600" responsive="true"
		[resizable]="false" [closable]="false">

		<table class="table editable" id="user-table" width="100%">
			<thead>
				<tr>
					<th>
						{{lookupColumnHeader}}
					</th>
				</tr>
			</thead>
			<tr height="110px">
				<td style="vertical-align: top;">

					<input type="text" name="name" class="form-control" [(ngModel)]="updateModel.name" #name="ngModel"
						class="input" required>
					<div *ngIf="updateForm.submitted && name.invalid" class="alert alert-danger">
						<div *ngIf="name.errors.required">Value is required</div>
					</div>

				</td>

				<td class="options" style="vertical-align: top;">
					<ul class="actions">
						<li class="confirm">
							<button id="finish" style="background-color: #36D9B0;border: 0;color: white;"><i
									class="la la-check commit" id="x1"></i></button>
						</li>
						<li class="cancel">
							<i class="la la-close" (click)="closeUpdateDialog($event)"></i>
						</li>
					</ul>
				</td>
			</tr>
		</table>

	</p-dialog>
</form>